import fetchHandler from './Handler';

export const Vendorforms = async (data: any) => {
	try {
		const response = await fetchHandler({
			method: 'POST',
			endpoint: 'vendors/',
			data,
		});
		return response;
	} catch (error) {
		console.error('API Error:', error);
		return null;
	}
};
export const VendorEditforms = async (data: any, id: any) => {
	try {
		const response = await fetchHandler({
			method: 'PUT',
			endpoint: `admin/vendor/${id}`,
			data,
		});
		return response;
	} catch (error) {
		console.error('API Error:', error);
		return null;
	}
};

export const VendorRequest = async () => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: 'admin/vendor/reqestvendor',
		});
		return response;
	} catch (error) {
		console.error('API Error:', error);
		return null;
	}
};
export const VendorApproved = async () => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: 'admin/vendor/approved',
		});
		return response;
	} catch (error) {
		console.error('API Error:', error);
		return null;
	}
};
export const VendorRequestGetsingle = async (id: any) => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `admin/vendor/reqestvendor/?id=${id}`,
		});
		return response;
	} catch (error) {
		console.error('API Error:', error);
		return null;
	}
};
export const VendorAprovedGetsingle = async (id: any) => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `admin/vendor/approved/?id=${id}`,
		});
		return response;
	} catch (error) {
		console.error('API Error:', error);
		return null;
	}
};
export const VendorRequestPUTsingle = async (id: any, data: any) => {
	try {
		const response = await fetchHandler({
			method: 'PUT',
			endpoint: `admin/vendor/${id}`,
			data,
		});
		return response;
	} catch (error) {
		console.error('API Error:', error);
		return null;
	}
};
export const VendorApprovedsingle = async (id: any, data: any) => {
	try {
		const response = await fetchHandler({
			method: 'PUT',
			endpoint: `admin/vendor/${id}/approve/`,
			data,
		});
		return response;
	} catch (error) {
		console.error('API Error:', error);
		return null;
	}
};
